"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function Icon() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M52.59 11.32L21.93 22.65v30c.26 9.12 4.75 16.51 10.22 22.16l3.1 2.94a67.46 67.46 0 0017.34 10.84 67.46 67.46 0 0017.34-10.88L73 74.77c5.47-5.65 10-13 10.21-22.16v-30zm23 26.05L49.07 63.91a3.1 3.1 0 01-4.37 0L32.17 51.38a2.5 2.5 0 113.53-3.54L46.88 59l25.19-25.16a2.5 2.5 0 013.53 3.53z"
  }));
}

var _default = Icon;
exports["default"] = _default;